<base-index-page
    [config]="baseIndexPageConfig"
    [service]="qualityManagementService"
    [idKey]="'riskTimeFrameId'"
    [subSectionSettings]="'deleteRiskTimeFrame'"
></base-index-page>
